import { FC, ReactNode } from "react";
import cn from "classnames";
import ExchangeIcon from "@Icons/PointsExchange/Exchange";

type ConversionInputsProps = {
  fromLabel: ReactNode;
  toLabel: ReactNode;
  fromInput: ReactNode;
  toInput: ReactNode;
  className?: string;
};

const ConversionInputs: FC<ConversionInputsProps> = ({ fromLabel, toLabel, fromInput, toInput, className }) => {
  return (
    <div className={cn("grid gap-y-1", className)} style={{ gridTemplateColumns: "1fr 2.5rem 1fr" }}>
      <div className="text-font-subtle col-start-1 row-start-1 text-xs font-medium uppercase tracking-wide">{fromLabel}</div>
      <div className="text-font-subtle col-start-3 row-start-1 text-xs font-medium uppercase tracking-wide">{toLabel}</div>
      <div className="col-start-1 row-start-2">{fromInput}</div>
      <ExchangeIcon className="text-font-subtle col-start-2 row-start-2 h-4 w-4 shrink-0 place-self-center" />
      <div className="col-start-3 row-start-2">{toInput}</div>
    </div>
  );
};

export default ConversionInputs;
